<template>
  <div>
    <v-breadcrumbs :items="itemsList" divider="-" class="px-0 pt-0">
      <template v-slot:divider>
        /
      </template>
    </v-breadcrumbs>
  </div>
</template>

<script>
const routeItems = {
  AccountBuildingTitlePage: [],
  AccountCkobStakeholders: [{ text: "Interesariusze" }],
  AccountCkobEntryRegistry: [{ text: "Wpisy" }],
  AccountBuildingLogParticipant: [
    {
      text: "Uczestnicy procesu budowlanego",
      to: "AccountBuildingLogParticipants"
    },
    { text: "archiwum" }
  ]
};

export default {
  name: "BreadCrumbs",
  props: {
    ckobNumber: {
      type: String,
      default: "Dziennik"
    }
  },
  data: () => ({}),
  computed: {
    items() {
      return [
        {
          text: "Rejestr KOB",
          disabled: false,
          exact: true,
          to: { name: "AccountCkobRegistry" }
        },
        {
          text: `${this.ckobNumber}`,
          disabled: false,
          exact: true,
          to: {
            name: "AccountCkobTitlePage",
            params: { id: this.$route.params.id }
          }
        }
      ];
    },
    itemsList() {
      const routeSubitems = routeItems[this.$route.name];
      if (routeSubitems) {
        const items = routeSubitems.map((i) => {
          const newI = {
            text: i.text,
            disabled: false,
            exact: true
          };
          if (i.to) {
            newI.to = {
              name: i.to,
              params: { id: this.$route.params.id }
            };
          }
          return newI;
        });

        return [...this.items, ...items];
      }
      return this.items;
    }
  }
};
</script>
